import UltMeta, { Meta } from "./UltMeta/index";

class ExchangeState extends UltMeta {
    REDEMPTION_SUCCESS = new Meta(1, "兑换成功", "");
    REDEMPTION_FAILED = new Meta(2, "兑换失败", "激活码已过期!");
    ACTIVATION_CODE_INVALID = new Meta(3, "激活码无效", "请输入正确的激活码!");
    ACTIVATION_FAILED = new Meta(4, "兑换失败", "该激活码已被兑换!");
    REDEMPTION_CLOSED = new Meta(5, "兑换失败", "该会员已关闭兑换，请联系平台!");
}

export const EXCHANGE_STATE = new ExchangeState();
